import { Badge } from '@/components/ui/badge';
import { DoorOpen, Feather, HeartHandshake, HandHeart, Compass } from 'lucide-react';
import { PILLARS } from './retreatsData';

const ICONS = { arrive: DoorOpen, release: Feather, reconnect: HeartHandshake, receive: HandHeart, return: Compass };

export const JustBePillars = () => (
  <section id="experience" className="py-20 px-6 bg-cream" data-testid="just-be-pillars">
    <div className="max-w-6xl mx-auto">
      <div className="text-center mb-14">
        <Badge className="bg-terracotta/10 text-terracotta mb-4">The Experience</Badge>
        <h2 className="font-heading text-4xl md:text-5xl font-bold text-forest mb-4">
          What Happens When You Just Be?
        </h2>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto">
          Every destination is different. The transformation is the same.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-6">
        {PILLARS.map((p, i) => {
          const Icon = ICONS[p.key];
          return (
            <div
              key={p.key}
              className="bg-white rounded-2xl p-6 shadow-sm border border-sand hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
              data-testid={`pillar-${p.key}`}
            >
              <div className="h-12 w-12 rounded-full bg-terracotta/10 flex items-center justify-center mb-4">
                <Icon className="h-6 w-6 text-terracotta" />
              </div>
              <p className="text-xs text-gray-400 font-bold mb-1">0{i + 1}</p>
              <h3 className="font-heading text-xl font-bold text-forest uppercase tracking-wide mb-2">{p.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{p.text}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
